export enum ToneType {
  EDUCATIONAL = "EDUCATIONAL",
  CONVERSATIONAL = "CONVERSATIONAL",
  ENTERTAINING = "ENTERTAINING",
  ENGAGING = "ENGAGING",
  INSPIRATIONAL = "INSPIRATIONAL",
}
